<template>
  <!-- grid-densa: ancora do teste de 9px SO nas grids desta tela. Ver scss/_custom.scss. -->
  <div class="grid-densa">
    <div class="d-flex">
        <div v-show="!flEdit" class="col-md-3">
            <SearchTravelAdvance  @search="search" :flDespesas="tabs === 1 ? true : false"></SearchTravelAdvance>
        </div>
        <div v-if="!flEdit" class="col-md-9">
            <b-tabs v-model="tabs">
                <b-tab :title="'Autorizações'">
                    <template slot="title">
                    <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Adiantamentos</span>
                    </template>
                    <TableTravelAdvance @cloneAdvance="cloneAdvance" ref="TableTravelAdvance" @editAdiantamento="editAdiantamento"></TableTravelAdvance>
                </b-tab>
                <b-tab :title="'Autorizações'">
                    <template slot="title">
                    <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Prestação de contas</span>
                    </template>
                    <TableTravelComision ref="TableTravelComision" :selectedIds="selectedIds" @selectedId="selectedIds.includes($event) ? selectedIds.splice(selectedIds.indexOf($event),1) : selectedIds.push($event)" @editAcount="editAcount"></TableTravelComision>
                </b-tab>
            </b-tabs>
        </div>
    </div>
    <div v-if="flEdit" class="w-100">
      <DetailsTravelAdvanced v-if="fladvanced" :dataDetails="dataDetails" @voltarPersonalizado="flEdit=false"></DetailsTravelAdvanced>
      <DetailsTravelComission v-else :dataDetails="dataDetails" @voltarPersonalizado="flEdit=false"></DetailsTravelComission>
    </div>
    <button v-if="tabs == 0 && !flEdit" id="btn-add-travel" @click="show()">+</button>
    <ModaAddTravelAdvance @success="addSucces" :key="modalKey" ref="ModaAddTravelAdvance"></ModaAddTravelAdvance>
    <b-modal
    hide-footer
    hide-header
    centered
    size="lg"
    ref="add-travel-concluido"
    id="add-travel-concluido">
      <div id="body-poupp-con">
        <div class="w-100 d-flex justify-content-center">
          <i class="fas fa-check-circle" id="icone-con"></i>
        </div>
        <div class="d-flex justify-content-center">
          <p id="des-con">A solicitação para reembolso de viagem foi criada com sucesso!!</p>
        </div>
        <div class="d-flex justify-content-center">
          <button id="btn-cont-con" @click="closeCon">CONTINUAR</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TravelReimbursement from './travelreimbursement'
export default TravelReimbursement
</script>

<style scoped>
  .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
  /* O `#app` na frente nao e enfeite: sem ele o `font-size: 28px !important` PERDE. A regra do
     teste de fonte (clients/_common.scss) e `#app.<tema> :not(i):not(...)`, que soma 1 id + 8
     classes; este seletor sozinho e 1 id + 1 atributo ([data-v-x] do scoped). Com !important dos
     dois lados quem decide e a especificidade, e id vale antes de classe: com o `#app` vira
     2 ids e ganha. Medido no browser contra o bundle: sem o prefixo o `+` saia 12px, nao 28px. */
  #app #btn-add-travel{
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: #008144;
    color: white;
    border: none;
    position: fixed;
    font-size: 28px !important;
    bottom: 50px;
    right: 1%;
    font-weight: bold;
  }
  #btn-add-travel:hover{
    background-color:  #025e33
  }
  .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
  #icone-con{
    font-size: 45px;
    color: #025e33;
  }
  #body-poupp-con{
    width: 100%;
  }
  #btn-cont-con{
    width: 50%;
    background: #025e33;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 10px;
    height: 50px;
  }
  #btn-cont-con:hover{
    background: #029b54;

  }
  #des-con{
    margin-top: 15px;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/travelreimbursement.vue